import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import TC from './component/TC';
import FooterInfo from './component/Footer';
import WelcomeMessage from './component/WelcomeNotify';

const Utility = () => (
  <div>
    <Container>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
        marginBottom: '5px',
        marginLeft: '15px',
      }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Utility</Typography>
      </Breadcrumbs>
      <Row>
        <Col md={12} />
      </Row>
      <Row>
        <Col md={4}>
          <TC />
        </Col>
        <Col md={4}>
          <FooterInfo />
        </Col>
        {/* <Col md={4}>
          <WelcomeMessage />
        </Col> */}
       
      </Row>
    </Container>
  </div>
  
  );

export default Utility;
